import type { RouteName } from './lib/router.js';
import type { StringKey } from './lib/strings.js';

export interface NavItem {
  readonly name: RouteName;
  readonly label: StringKey;
  /** Shown in the phone tab bar. */
  readonly bottom: boolean;
}

export const NAV: ReadonlyArray<NavItem> = [
  { name: 'today', label: 'nav_today', bottom: true },
  { name: 'stock', label: 'nav_stock', bottom: true },
  { name: 'sales', label: 'nav_sales', bottom: true },
  { name: 'purchases', label: 'nav_purchases', bottom: false },
  { name: 'parties', label: 'nav_parties', bottom: true },
  { name: 'payments', label: 'nav_payments', bottom: false },
  { name: 'returns', label: 'nav_returns', bottom: false },
  { name: 'money', label: 'nav_money', bottom: false },
  { name: 'bank', label: 'nav_bank', bottom: false },
  { name: 'reports', label: 'nav_reports', bottom: false },
  { name: 'books', label: 'nav_books', bottom: false },
];
